import { Link } from "react-router-dom";
import { Phone, MapPin, Clock, ExternalLink } from "lucide-react";

const towns = ["Trout", "Jena", "Urania", "Olla", "Tullos", "Alexandria", "Pineville", "Ball", "Pollock", "Dry Prong", "Georgetown", "Winnfield"];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-navy-deep text-slate-300 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <img src="/logo.png" alt="McCann and Sons HVAC Service logo" className="h-16 w-auto mb-5" />
          <p className="text-sm leading-relaxed text-slate-400">
            Family-owned mechanical HVAC service, repair, and full system installation for residential
            and commercial clients across Central Louisiana — day, night, weekends, and holidays.
          </p>
          <div className="mt-5 inline-flex items-center gap-2 border border-ember/40 text-ember font-mono text-xs uppercase tracking-[0.2em] px-3 py-2 rounded-sm">
            <span className="h-1.5 w-1.5 rounded-full bg-ember animate-pulse-dot" />
            24/7 Emergency Dispatch
          </div>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-frost mb-5">Pages</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link data-testid="footer-nav-home" to="/" className="hover:text-white transition-colors">Home</Link></li>
            <li><Link data-testid="footer-nav-about" to="/about" className="hover:text-white transition-colors">About Us</Link></li>
            <li><Link data-testid="footer-nav-services" to="/services" className="hover:text-white transition-colors">Services</Link></li>
            <li><Link data-testid="footer-nav-contact" to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            <li className="pt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Service Areas</li>
            <li><Link data-testid="footer-area-jena" to="/service-areas/jena" className="hover:text-white transition-colors">HVAC Repair Jena, LA</Link></li>
            <li><Link data-testid="footer-area-alexandria" to="/service-areas/alexandria" className="hover:text-white transition-colors">HVAC Repair Alexandria, LA</Link></li>
            <li><Link data-testid="footer-area-pineville" to="/service-areas/pineville" className="hover:text-white transition-colors">HVAC Repair Pineville, LA</Link></li>
            <li>
              <a data-testid="footer-nav-blog" href="https://blog.jcmandsonshvac.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors inline-flex items-center gap-1">
                Blog <ExternalLink className="h-3 w-3" />
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-frost mb-5">Services</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/services#residential" className="hover:text-white transition-colors">Residential HVAC</Link></li>
            <li><Link to="/services#commercial" className="hover:text-white transition-colors">Commercial Mechanical HVAC</Link></li>
            <li><Link to="/services#installation" className="hover:text-white transition-colors">System Replacement & Installation</Link></li>
            <li><Link to="/services#maintenance" className="hover:text-white transition-colors">Preventive Seasonal Maintenance</Link></li>
            <li><Link to="/services#emergency" className="hover:text-white transition-colors">24/7 Emergency Repairs</Link></li>
            <li><Link to="/services#iaq" className="hover:text-white transition-colors">Indoor Air Quality</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-frost mb-5">Contact</h4>
          <ul className="space-y-3.5 text-sm">
            <li className="flex gap-2.5">
              <MapPin className="h-4 w-4 text-ember shrink-0 mt-0.5" />
              <span>164 Dixie Lane<br />Trout, Louisiana 71371</span>
            </li>
            <li>
              <a data-testid="footer-call-link" href="tel:3183122112" className="flex gap-2.5 hover:text-white transition-colors">
                <Phone className="h-4 w-4 text-ember shrink-0 mt-0.5" />
                (318) 312-2112
              </a>
            </li>
            <li className="flex gap-2.5">
              <Clock className="h-4 w-4 text-ember shrink-0 mt-0.5" />
              <span>Open 24 Hours — 7 Days a Week</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} McCann and Sons HVAC Service. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            Serving {towns.slice(0, 6).join(" · ")} & all of Central Louisiana
          </p>
        </div>
      </div>
    </footer>
  );
}
